import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation Course_enrollUsers($courseId: ID!, $users: [ID]) {
    Course_enrollUsers(courseId: $courseId, users: $users) {
      value
    }
  }
`;

const CourseEnrollUsers = async (courseId, users) =>
  graphql(mutation, { courseId, users })
    // eslint-disable-next-line camelcase
    .then(({ Course_enrollUsers }) => Course_enrollUsers)
    .catch(e => e);

export default CourseEnrollUsers;
